import React, { createContext, useContext } from 'react';
import { LEGACY_TERMS } from './legacyTerms';
const TermsContext = createContext(LEGACY_TERMS);
/** Portals wrap their app in <TermsProvider value={PORTAL_TERMS}>. Admin mounts nothing and keeps LEGACY_TERMS. */
export const TermsProvider = ({ value, children }) => (React.createElement(TermsContext.Provider, { value: value }, children));
export function useTerms() {
    return useContext(TermsContext);
}
